import * as React from 'react';
export var ImageTile = function (_a) {
    var image = _a.image, alt = _a.alt, size = _a.size;
    return (React.createElement("div", { className: "tile ".concat(size) },
        React.createElement("img", { src: image, alt: alt })));
};
//# sourceMappingURL=index.js.map